import { render, staticRenderFns } from "./Newsletters.vue?vue&type=template&id=975abd1e&scoped=true&"
import script from "./Newsletters.vue?vue&type=script&lang=ts&"
export * from "./Newsletters.vue?vue&type=script&lang=ts&"
import style0 from "./Newsletters.vue?vue&type=style&index=0&id=975abd1e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975abd1e",
  null
  
)

export default component.exports